import React, { Component } from 'react';
import PropTypes from 'prop-types';


import IconButton from '@mui/material/IconButton';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import DownloadIcon from '@mui/icons-material/CloudDownload';
import {saveAs} from 'file-saver';
import { Box, Button } from '@mui/material';

const s:any = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    background: 'background.paper',
  },
  gridList: {
    width: 500,
    height: 450,
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  titleBar: {
    background:
      'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
      'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  icon: {
    color: 'white',
  },
  videobox: {
    objectFit: "contain",
    width: 240,
    height: 200,
  },
  video:{
    position: 'absolute', 
    right: 0, 
    bottom: 0,
    minWidth: '100%', 
    minHeight: '100%',
    width: 'auto', 
    height: 'auto', 
    zIndex: "-100",
    backgroundSize: 'cover',
    overflow: 'hidden'
  }
};

class ResourceView extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      count:0
    };
  }

  handleClick = (name:any) => (event:any,value?:any) => {
    var {result} = this.props;
    console.log('result',result,value,name);
    var blob = new Blob(value);
    saveAs(blob);
  } 

  render() {
    const { tileData, classes} = this.props;

    return (
      <Box sx={{...s.root}}>
        <ImageList rowHeight={200} gap={1} sx={{...s.gridList}}>
          {tileData.map((tile:any) => (
            <ImageListItem key={tile.resid} cols={tile.featured ? 2 : 1} rows={tile.featured ? 2 : 1}>
              {tile.type==='image'?
              <Box component='img' id={tile.resid} src={tile.src} alt=""/>
              :<Box sx={{...s.videobox}}>
                <Box component='video' id={tile.resid} src={tile.src} sx={{...s.videobox}} muted playsInline controls></Box>
              </Box>}
              <ImageListItemBar
                title={tile.title}
                position="top"
                actionIcon={
                  <Button sx={{...s.icon}} onClick={this.handleClick(tile.resid)}>
                    <DownloadIcon />
                  </Button>
                }
                actionPosition="right"
                sx={{...s.titleBar}}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
    );
  }
}

ResourceView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default ResourceView;